/** Site analytics — Statistics › Visits & Clicks (pages/todaymall/statistics). */
export default {
  'pages.siteAnalytics.tab.analysis': "Visits & Clicks",
  'pages.siteAnalytics.tab.realtime': "Realtime",
  'pages.siteAnalytics.loadFailed': "Could not load the statistics. Please try again shortly.",
  'pages.siteAnalytics.notCollecting': "Visit collection is turned off. Turn the site analytics feature on at the server to start gathering data.",
  'pages.siteAnalytics.noDataYet': "No visits have been collected yet. They will appear here once collection is on and visitors arrive.",
  'pages.siteAnalytics.firstDataDay': "Visit data starts on {date}. Earlier dates are empty.",

  'pages.siteAnalytics.filter.today': "Today",
  'pages.siteAnalytics.filter.last7': "Last 7 days",
  'pages.siteAnalytics.filter.last30': "Last 30 days",
  'pages.siteAnalytics.filter.last90': "Last 90 days",
  'pages.siteAnalytics.filter.deviceAll': "All devices",
  'pages.siteAnalytics.filter.visitorAll': "New & returning",
  'pages.siteAnalytics.filter.visitorNew': "New visitors",
  'pages.siteAnalytics.filter.visitorReturning': "Returning visitors",
  'pages.siteAnalytics.filter.compare': "Compared with {from} ~ {to} · Korea time",
  'pages.siteAnalytics.filter.kst': "Korea time",
  'pages.siteAnalytics.view.chart': "Chart view",
  'pages.siteAnalytics.view.table': "Table view",

  'pages.siteAnalytics.device.pc': "PC",
  'pages.siteAnalytics.device.mobile_web': "Mobile browser",
  'pages.siteAnalytics.device.android': "Android app",
  'pages.siteAnalytics.device.ios': "iOS app",

  'pages.siteAnalytics.kpi.uv': "Visitors (UV)",
  'pages.siteAnalytics.kpi.uv.tip': "Distinct visitors in the period. Logged-in visitors are counted by account, others by browser or app install. Visits that opened one page that was never on screen and never clicked (automated scrapers) are left out of every figure.",
  'pages.siteAnalytics.kpi.pv': "Page views (PV)",
  'pages.siteAnalytics.kpi.pv.tip': "Times a page (or app screen) was opened. Changing only a search term or filter is not counted.",
  'pages.siteAnalytics.kpi.avgDwell': "Avg. time on site",
  'pages.siteAnalytics.kpi.avgDwell.tip': "Average time the screen was actually visible per visit. Time spent in another tab is left out.",
  'pages.siteAnalytics.kpi.bounceRate': "Bounce rate",
  'pages.siteAnalytics.kpi.bounceRate.tip': "Share of visits that ended after a single page. Lower is better.",
  'pages.siteAnalytics.kpi.clicks': "Total clicks",
  'pages.siteAnalytics.kpi.clicks.tip': "On the web, every link and button click. In the apps, only the add-to-cart and buy-now buttons.",
  'pages.siteAnalytics.kpi.vsPrevious': "vs. previous period",
  'pages.siteAnalytics.kpi.noBaseline': "No earlier data to compare",

  'pages.siteAnalytics.duration.hm': "{h}h {m}m",
  'pages.siteAnalytics.duration.ms': "{m}m {s}s",
  'pages.siteAnalytics.duration.s': "{s}s",
  'pages.siteAnalytics.unit.people': "{n}",
  'pages.siteAnalytics.unit.times': "{n}",

  'pages.siteAnalytics.trend.title': "UV / PV trend",
  'pages.siteAnalytics.trend.uv': "UV",
  'pages.siteAnalytics.trend.pv': "PV",
  'pages.siteAnalytics.trend.note': "Daily UV is that day's visitors, so someone who came on several days is counted each day (the sum exceeds the period UV).",
  'pages.siteAnalytics.trend.col.date': "Date",

  'pages.siteAnalytics.devices.title': "Devices",
  'pages.siteAnalytics.devices.center': "Visitors",
  'pages.siteAnalytics.devices.tip': "Share of visitors. Apps are counted from devices that have the new version installed.",

  'pages.siteAnalytics.topPages.title': "Top 10 pages",
  'pages.siteAnalytics.topPages.col.page': "Page",
  'pages.siteAnalytics.topPages.col.pv': "PV",
  'pages.siteAnalytics.topPages.col.uv': "UV",
  'pages.siteAnalytics.topPages.col.avgDwell': "Avg. time",
  'pages.siteAnalytics.topPages.col.bounceRate': "Bounce rate",
  'pages.siteAnalytics.topPages.bounceTip': "Of the visits that entered on this page, the share that viewed nothing else.",

  'pages.siteAnalytics.modules.title': "Click data by module",
  'pages.siteAnalytics.modules.col.module': "Module",
  'pages.siteAnalytics.modules.col.impressions': "Impressions",
  'pages.siteAnalytics.modules.col.clicks': "Clicks",
  'pages.siteAnalytics.modules.col.ctr': "CTR",
  'pages.siteAnalytics.modules.tip': "Impressions are measured on the web only (an area counts once when at least half of it stays in view for a second). CTR is web clicks ÷ impressions; the click count also includes app button clicks.",

  'pages.siteAnalytics.funnel.title': "Purchase funnel",
  'pages.siteAnalytics.funnel.desc': "Visitors at each step from browsing to payment, and their share of the first step.",
  'pages.siteAnalytics.funnel.tip': "A visitor who reached a later step is included in the earlier ones. Order created and Paid are counted from real orders made during the visit; an order paid later still counts as paid. Guest-link orders are not included.",
  'pages.siteAnalytics.funnel.stepRate': "of previous step",
  'pages.siteAnalytics.funnel.step.list': "Listing / search",
  'pages.siteAnalytics.funnel.step.detail': "Product detail",
  'pages.siteAnalytics.funnel.step.cart': "Cart",
  'pages.siteAnalytics.funnel.step.checkout': "Checkout started",
  'pages.siteAnalytics.funnel.step.order': "Order created",
  'pages.siteAnalytics.funnel.step.paid': "Paid",

  'pages.siteAnalytics.page.home': "Home",
  'pages.siteAnalytics.page.overseas': "Overseas",
  'pages.siteAnalytics.page.mall': "Mall",
  'pages.siteAnalytics.page.live': "Live",
  'pages.siteAnalytics.page.search': "Search",
  'pages.siteAnalytics.page.image_search': "Image search",
  'pages.siteAnalytics.page.category': "Category",
  'pages.siteAnalytics.page.product': "Product detail",
  'pages.siteAnalytics.page.cart': "Cart",
  'pages.siteAnalytics.page.checkout': "Order form (checkout)",
  'pages.siteAnalytics.page.checkout_payment': "Payment",
  'pages.siteAnalytics.page.order_complete': "Order complete",
  'pages.siteAnalytics.page.mall_store': "Store",
  'pages.siteAnalytics.page.live_products': "Live products",
  'pages.siteAnalytics.page.live_search': "Live search",
  'pages.siteAnalytics.page.live_seller': "Seller page",
  'pages.siteAnalytics.page.shop': "Seller shop",
  'pages.siteAnalytics.page.picks': "Picks",
  'pages.siteAnalytics.page.share_rewards': "Share rewards",
  'pages.siteAnalytics.page.promo_video': "Promo video",
  'pages.siteAnalytics.page.mypage': "My page",
  'pages.siteAnalytics.page.mypage_order': "My orders",
  'pages.siteAnalytics.page.guest_order': "Guest order lookup",
  'pages.siteAnalytics.page.guest_buy': "Guest purchase link",
  'pages.siteAnalytics.page.message': "Messages & inquiries",
  'pages.siteAnalytics.page.help': "Help center",
  'pages.siteAnalytics.page.auth': "Sign in / sign up",
  'pages.siteAnalytics.page.info': "Company & terms",
  'pages.siteAnalytics.page.other': "Other",

  'pages.siteAnalytics.module.main_banner': "Main banner",
  'pages.siteAnalytics.module.product_card': "Product card",
  'pages.siteAnalytics.module.category_icon': "Category icon",
  'pages.siteAnalytics.module.store_area': "Recommended stores",
  'pages.siteAnalytics.module.live_area': "Live area",
  'pages.siteAnalytics.module.market_area': "Marketplace area",
  'pages.siteAnalytics.module.event_banner': "Event banner",
  'pages.siteAnalytics.module.search_button': "Search button",
  'pages.siteAnalytics.module.cart_button': "Add-to-cart button",
  'pages.siteAnalytics.module.buy_now_button': "Buy-now button",

  'pages.siteAnalytics.realtime.live': "Live",
  'pages.siteAnalytics.realtime.autoRefresh': "Refreshes every 10 s",
  'pages.siteAnalytics.realtime.sampledAt': "As of {time}",
  'pages.siteAnalytics.realtime.unavailable': "Realtime presence could not be read (connection to the presence store). The numbers below do not mean nobody is online.",
  'pages.siteAnalytics.realtime.kpi.current': "Visitors online now",
  'pages.siteAnalytics.realtime.kpi.current.tip': "Visitors with a page open in the last minute. A hidden tab drops out after a minute.",
  'pages.siteAnalytics.realtime.kpi.todayVisitors': "Visitors today",
  'pages.siteAnalytics.realtime.kpi.todayPageviews': "Page views today",
  'pages.siteAnalytics.realtime.kpi.mobileShare': "Mobile share",
  'pages.siteAnalytics.realtime.kpi.mobileShare.tip': "Share of current visitors not on a PC browser (mobile browsers + apps).",
  'pages.siteAnalytics.realtime.kpi.avgDwell': "Avg. time on site",
  'pages.siteAnalytics.realtime.vs5min': "vs. 5 min ago",
  'pages.siteAnalytics.realtime.vsYesterday': "vs. same time yesterday",
  'pages.siteAnalytics.realtime.pcShare': "PC {rate}",

  'pages.siteAnalytics.realtime.chart.title': "Visitors online · last hour",
  'pages.siteAnalytics.realtime.chart.summary': "Now {current} · peak {peak}",
  'pages.siteAnalytics.realtime.chart.series': "Online",
  'pages.siteAnalytics.realtime.devices.title': "Devices online",
  'pages.siteAnalytics.realtime.devices.center': "Online",
  'pages.siteAnalytics.realtime.topPages.title': "Top 5 pages right now",
  'pages.siteAnalytics.realtime.topPages.note': "Apps older than the new version do not report the screen being viewed and are not shown here.",

  'pages.siteAnalytics.realtime.list.title': "Visitors online now",
  'pages.siteAnalytics.realtime.list.total': "{n} in total",
  'pages.siteAnalytics.realtime.list.truncated': "Too many visitors to list — showing the {n} most recent.",
  'pages.siteAnalytics.realtime.list.search': "Search ID, IP, country, browser, page",
  'pages.siteAnalytics.realtime.chip.all': "All",
  'pages.siteAnalytics.realtime.chip.member': "Members",
  'pages.siteAnalytics.realtime.chip.guest': "Guests",
  'pages.siteAnalytics.realtime.chip.mobile': "Mobile",
  'pages.siteAnalytics.realtime.chip.pc': "PC",
  'pages.siteAnalytics.realtime.chip.kr': "Korea",
  'pages.siteAnalytics.realtime.chip.foreign': "Overseas",
  'pages.siteAnalytics.realtime.col.connectedAt': "Started",
  'pages.siteAnalytics.realtime.col.visitor': "Visitor ID",
  'pages.siteAnalytics.realtime.col.nickname': "Member",
  'pages.siteAnalytics.realtime.col.ip': "IP address",
  'pages.siteAnalytics.realtime.col.country': "Country",
  'pages.siteAnalytics.realtime.col.device': "Device",
  'pages.siteAnalytics.realtime.col.browser': "Browser",
  'pages.siteAnalytics.realtime.col.page': "Current page",
  'pages.siteAnalytics.realtime.col.duration': "Time on site",
  'pages.siteAnalytics.realtime.col.status': "Status",
  'pages.siteAnalytics.realtime.status.active': "Online",
  'pages.siteAnalytics.realtime.status.idle': "Idle",
  'pages.siteAnalytics.realtime.export.sheet': "Online visitors",
  'pages.siteAnalytics.realtime.export.empty': "There are no visitors to export.",
};
